import { Injectable, inject } from '@angular/core';
import {Resolve} from '@angular/router';

import {RoutesService, NavigationService, VisitList, ProblemInstanceService} from 'planner-shared';

@Injectable({
    providedIn: 'root'
})
export class RoutePlanningResolver implements Resolve<VisitList> {
    private readonly navigationService = inject(NavigationService);
    private readonly routeService = inject(RoutesService);
    private readonly problemInstanceService = inject(ProblemInstanceService);


    resolve(): Promise<VisitList> {
        return new Promise(resolve => {
            this.problemInstanceService.getProblemInstance().subscribe(
                () => {
                    this.routeService.getRoutes()
                        .subscribe(result => {
                            if (result.optimizationRunning || !result.routes) {
                                this.navigationService.navigateToStep1();
                                return;
                            }
                            resolve(result.routes);
                        });
                }
            );
        });
    }
}
